import { createElement } from 'react';
import { func, bool, object } from 'prop-types';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import _Hidden from 'reakit/Hidden';

var HiddenContainer = function HiddenContainer(_ref) {
  var children = _ref.children,
      defaultVisible = _ref.defaultVisible,
      initialState = _ref.initialState,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "defaultVisible", "initialState"]);

  return createElement(_Hidden.Container, _extends({
    initialState: _objectSpread({
      visible: defaultVisible
    }, initialState)
  }, props), function (_ref2) {
    var visible = _ref2.visible,
        rest = _objectWithoutPropertiesLoose(_ref2, ["visible"]);

    return children(_objectSpread({
      isVisible: visible
    }, rest));
  });
};

var hiddenContainerPropTypes = {
  children: func.isRequired,
  defaultVisible: bool,
  initialState: object
};
HiddenContainer.propTypes = hiddenContainerPropTypes;
var hiddenContainerDefaultProps = {
  defaultVisible: false,
  initialState: {}
};
HiddenContainer.defaultProps = hiddenContainerDefaultProps;
export default HiddenContainer;
export { HiddenContainer, hiddenContainerDefaultProps, hiddenContainerPropTypes };